import PropTypes from 'prop-types';

import NavigationBreadcrumbsContainer from '../../../containers/NavigationBreadcrumbsContainer/NavigationBreadcrumbsContainer';

import Asset from '../../../entities/asset';

import './AssetDetailsHeader.scss';

const AssetDetailsHeader = ( {
	asset, projectID
} ) => (
	asset && (
		<div className="AssetDetailsHeader">
			<NavigationBreadcrumbsContainer
				projectID={projectID}
				folderID={asset.folderID}
				assetID={asset.id}
			/>
		</div>
	)
);

AssetDetailsHeader.propTypes = {
	asset: PropTypes.instanceOf( Asset ),
	projectID: PropTypes.number
};

AssetDetailsHeader.defaultProps = {
	asset: undefined,
	projectID: undefined
};

export default AssetDetailsHeader;
